import { MotionReveal } from "../../components/MotionReveal";

export default function DigitalNativeIndustryPage() {
  return (
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="pt-6 sm:pt-10">
        <MotionReveal>
          <div className="glass-panel rounded-3xl p-8 sm:p-10">
            <div className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-4 py-2 text-xs uppercase tracking-[0.18em] text-[var(--text-secondary)]">
              Digital-Native Enterprises
            </div>
            <h1 className="mt-6 font-[var(--font-display)] text-4xl sm:text-5xl tracking-tight text-white">
              Digital-Native AIOps & Observability
            </h1>
            <p className="mt-4 max-w-3xl text-sm sm:text-base text-[var(--text-secondary)]">
              Scale fast. Stay reliable. Optimize costs.
            </p>
            <div className="mt-8 grid gap-4 lg:grid-cols-2">
              <div className="rounded-3xl border border-white/10 bg-white/3 p-6">
                <div className="text-xs uppercase tracking-[0.22em] text-[var(--text-secondary)]">Challenge</div>
                <div className="mt-3 grid gap-2 text-sm text-[var(--text-secondary)]">
                  <div>Multiple deployments per day</div>
                  <div>Hundreds of microservices and dynamic dependencies</div>
                  <div>Cloud cost overruns vs observability spend</div>
                  <div>SRE pressure with small teams</div>
                </div>
              </div>
              <div className="rounded-3xl border border-white/10 bg-white/3 p-6">
                <div className="text-xs uppercase tracking-[0.22em] text-[var(--text-secondary)]">Outcomes</div>
                <div className="mt-3 grid gap-2 text-sm text-[var(--text-secondary)]">
                  <div>✓ Faster innovation cycles</div>
                  <div>✓ 30% lower cloud TCO</div>
                  <div>✓ High availability at scale</div>
                  <div>✓ Happier SRE teams</div>
                </div>
              </div>
            </div>
            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center rounded-xl px-5 py-3 text-sm font-medium text-[#061019] bg-[var(--accent-primary)] hover:brightness-110"
              >
                Request Digital-Native Assessment
              </a>
              <a
                href="/architecture"
                className="inline-flex items-center justify-center rounded-xl px-5 py-3 text-sm font-medium text-white border border-white/15 bg-white/5 hover:bg-white/8"
              >
                View Architecture
              </a>
            </div>
          </div>
        </MotionReveal>
      </div>
      <div className="h-12" />
    </div>
  );
}
